/**
 * Parses a date-only API value ("YYYY-MM-DD", optionally followed by a time part) into a local-midnight Date,
 * so the calendar day is not shifted by `new Date('YYYY-MM-DD')` being read as UTC midnight.
 */
export function parseDateOnly(value: string | null | undefined): Date | null {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? '');
    if (!match) {
        return null;
    }
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}
